import style from '@/fsd/shared/ui/static/css/commonStyle.module.scss';
import cx from 'classnames';
import React from 'react';

export const BodyTable = ({ bodyClassName = '', children, ...props }) => {
  return (
    <div className={cx(style.BodyTable, bodyClassName)} {...props}>
      {children}
    </div>
  );
};

export default BodyTable;
